var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconCompleteEdit48Line = function SvgIconCompleteEdit48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.2 17.769h3.1v7.78h3.4v-9.48a1.502 1.502 0 0 0-.18-.74c-.02-.04-.04-.07-.06-.1-.07-.13-.16-.25-.26-.35l-6-6c-.11-.11-.23-.19-.36-.27-.03-.02-.06-.04-.1-.05-.23-.11-.48-.18-.74-.18H16.6a5.31 5.31 0 0 0-5.3 5.3v18.8c0 2.92 2.38 5.3 5.3 5.3h8.7v-3.4h-8.7a1.9 1.9 0 0 1-1.9-1.9v-18.8c0-1.05.85-1.9 1.9-1.9h10.7v3.1c0 1.6 1.3 2.9 2.9 2.9v-.01Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m39.8 28.049-6.55 6.52-3.01-3.25-2.49 2.31 3.79 4.08c.42.46 1.02.72 1.64.74h.04c.6 0 1.19-.24 1.62-.67l7.35-7.32-2.4-2.41h.01Z",
    fill: "current"
  })));
};
export default SvgIconCompleteEdit48Line;